module.exports = __webpack_public_path__ + "static/media/icon-font-underline.1f0759cc.svg";